import { fillNodesWithAdditionalData } from './additional-data';
import { createTreeNodes } from './structure';
import { TreeInitializationOptions } from './types';

export async function initializeTree(options: TreeInitializationOptions) {
  await createTreeNodes(options);
  await fillNodesWithAdditionalData(options);
}
